exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-0dadaa98]{font-size:16px;font-weight:500}.inTotal[data-v-0dadaa98]{margin:0;line-height:32px;margin-right:14px}.selIcon[data-v-0dadaa98]{width:25px;height:25px;line-height:25px;display:inline-block;text-align:center;cursor:pointer;border-radius:3px}.selIcon .iconfont[data-v-0dadaa98]{font-size:13px;color:#fff}\n", ""]);

// exports
